<template>
	<vs-popup
		:active.sync="activeProp"
		:title="$t('addOrderComment')"
	>

		<vue-editor v-model="newComment" />

        <div class="set-ticket-done__controls">
			<vs-button
				@click="confirm"
				color="primary"
			>{{ $t('save') }}</vs-button>
    
			<vs-button
				@click="close"
				color="#9a9a9a"
				type="flat"
			>{{ $t('cancel') }}</vs-button>
		</div>
	</vs-popup>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
	name: "AddNewCommentToOrder",
	props: {
		active: {
			required: true,
			type: Boolean
		},
	},
	data() {
		return {
            newComment: null,
		}
	},
    components: {
        VueEditor,
    },
    watch: { 
		activeProp(newValue) {
			if(newValue === false) {
				this.reward = 0;
			}
		}
	},
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},
	methods: {
		confirm() {
			this.$emit("confirm", this.newComment);
			this.activeProp = false;
		},
        close() {
			this.activeProp = false;
		},
	},
};
</script>

<style scoped lang="scss">
    .con-vs-popup .vs-popup  {
        width: 100% !important;
        max-width: 800px !important;
    }
    .set-ticket-done__controls {
        text-align: right;
    }
	.tox {
		z-index: 999992 !important;
	}
	.tox-tiered-menu{
		z-index: 999993 !important;
	}
	.tox-menu {
		z-index: 999994 !important;
	}
	
</style>